// Class: openfl.display.IBitmapDrawable

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;

// Constructor

var IBitmapDrawable = function() {}

// Meta

IBitmapDrawable.__name__ = "openfl.display.IBitmapDrawable";
IBitmapDrawable.__isInterface__ = true;
IBitmapDrawable.prototype = {
	
};
IBitmapDrawable.prototype.__class__ = IBitmapDrawable.prototype.constructor = $hxClasses["openfl.display.IBitmapDrawable"] = IBitmapDrawable;

// Init



// Statics




// Export

exports.default = IBitmapDrawable;